import { BREAKPOINT } from 'Constants'
import { getContrastColor } from './utils/helper'

const DARK_GREY = '#8F8F8F'
const LIGHT_GREY = '#D6D6D6'

const getTheme = ({ brand, bg, primaryText, fontFamily, waitlistText }) => {
  return {
    color: {
      brand,
      bg,
      primaryText,
      secondaryText: getContrastColor(bg),
      borderDark: DARK_GREY,
      borderLight: LIGHT_GREY,
      success: '#45D67F',
      error: '#E65055',
      waitlistText: waitlistText || '#e5393f'
    },
    fontFamily: `${fontFamily}`,
    spacingUnit: 0.5,
    breakpoint: {
      xl: BREAKPOINT.xlarge,
      lg: BREAKPOINT.large,
      md: BREAKPOINT.medium,
      sm: BREAKPOINT.small,
      scheduleSm: BREAKPOINT.scheduleMobile - 1
    }
  }
}

export default getTheme
